// ProfessionalExperienceView.jsx
import { Icon } from '@iconify/react';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import dayjs from 'dayjs';
import { SectionTitle } from 'modules/shared/components';
import { EMPLOYMENT_TYPES, MONTHS, WORK_TYPES } from '../constants';
import { formatExperienceDuration } from '../utils';

export default function ProfessionalExperienceView({ data = [] }) {
  return (
    <div className='column gap-3'>
      <SectionTitle title='Professional experience' />

      {data.length === 0 ? (
        <Alert severity='info'>No professional experience found</Alert>
      ) : (
        data.map((item, index) => <ExperienceRow key={item.id || index} data={item} />)
      )}
    </div>
  );
}

function ExperienceRow({ data }) {
  const start = dayjs(data.startDate);
  const end = data.isCurrent ? null : dayjs(data.endDate);

  const resolvedStartMonth = start.month() + 1;
  const resolvedStartYear = start.year();

  const resolvedEndMonth = end ? end.month() + 1 : null;
  const resolvedEndYear = end ? end.year() : null;

  const duration = formatExperienceDuration({
    startMonth: resolvedStartMonth,
    startYear: resolvedStartYear,
    endMonth: resolvedEndMonth,
    endYear: resolvedEndYear,
    isCurrent: data.isCurrent,
  });

  const startDateString = `${MONTHS[resolvedStartMonth]} ${resolvedStartYear}`;
  const endDateString = data.isCurrent
    ? 'Present'
    : `${MONTHS[resolvedEndMonth]} ${resolvedEndYear}`;

  return (
    <Stack direction='row' gap={2}>
      <Icon icon='mdi:company' width={24} className='text--secondary' />

      <div className='column gap-1'>
        <span>{data.title}</span>

        <div className='row'>
          <span>{data.company}</span>
          <DotSeparator />
          <span>{EMPLOYMENT_TYPES[data.employmentType] || data.employmentType}</span>
        </div>

        <div className='row'>
          <span>
            {startDateString} - {endDateString}
          </span>
          <span>({duration})</span>
        </div>

        <div className='row'>
          <span>{data.location}</span>
          <DotSeparator />
          <span>{WORK_TYPES[data.locationType]}</span>
        </div>
      </div>
    </Stack>
  );
}

function DotSeparator() {
  return (
    <Box
      aria-hidden
      component='span'
      sx={{
        width: 4,
        height: 4,
        borderRadius: '50%',
        backgroundColor: 'currentColor',
        margin: '0 6px',
        opacity: 0.6,
      }}
    />
  );
}
